import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{outlet}}",{ moduleName: "@banking/savings-onboarding-app/templates/signup/link-external-bank-account.hbs" })